import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="site-footer">
  <div className="footer-content">
    <div className="footer-left">
      <span>&copy; 2024 Knowledge Buddy. All rights reserved.</span>
    </div>
    {/* <div className="footer-links">
      <a href="/pages/index.html">Home</a>
      <a href="/pages/tutorial.html">Tutorial</a>
      <a href="/pages/aboutus.html">About</a>
      <a href="/pages/contactus.html">Contact</a>
    </div> */}
  </div>
</footer>
  )
}

export default Footer